import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from 'src/model/customer.model';

import { Loan } from 'src/model/loan.model';
import { Profile } from 'src/model/profile.model';

@Component({
    selector: 'app-shared-loan-list',
    templateUrl: './shared-loan-list.component.html',
    styleUrls: ['./shared-loan-list.component.scss'],
    standalone: false
})
export class SharedLoanListComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);

  @Input() sharedLoanList: Loan[] = [];
  @Input() viewCustomer: Customer;
  @Input() selectedProfile: Profile;

  ngOnInit(): void {
  }

  reset() {
    this.activeModal.close();
  }

}
